import { isEmpty } from 'lodash';

export const validateNoCreditScore = ({ customDependencies }) => {
  const { noCreditScores, borrowers } = customDependencies;
  return noCreditScores || isEmpty(borrowers);
};
